module.exports = __webpack_public_path__ + "static/media/01_A1_01.b3a1bbce.png";